// src/components/PulseCheckTimer.js
import React, { useState, useEffect } from 'react';

export default function PulseCheckTimer({ isCPR, onNoPulse, onROSC }) {
    const [pulseCheckTime, setPulseCheckTime] = useState(() => {
        const savedTime = localStorage.getItem('pulseCheckTime');
        return savedTime ? parseInt(savedTime, 10) : 120;
    });

    useEffect(() => {
        let interval = null;
        if (isCPR) {
            interval = setInterval(() => {
                setPulseCheckTime(prev => {
                    const newTime = prev > 0 ? prev - 1 : 0;
                    localStorage.setItem('pulseCheckTime', newTime);
                    return newTime;
                });
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isCPR]);

    const handleNoPulse = () => {
        setPulseCheckTime(120);
        localStorage.setItem('pulseCheckTime', 120);
        onNoPulse();
    };

    const handleROSC = () => {
        setPulseCheckTime(120);
        localStorage.setItem('pulseCheckTime', 120);
        onROSC();
    };

    return (
        <div className="pulse-check-timer">
            <h2>Pulse Check Timer</h2>
            <p style={{ color: pulseCheckTime <= 10 && pulseCheckTime > 0 ? 'red' : 'black' }}>
                {pulseCheckTime > 0 ? `Pulse Check in: ${pulseCheckTime} seconds` : 'Pulse Check is due'}
            </p>
            {pulseCheckTime === 0 && (
                <div className="pulse-check-actions">
                    <button className="btn" onClick={handleNoPulse}>No Pulse</button>
                    <button className="btn" onClick={handleROSC}>ROSC</button>
                </div>
            )}
        </div>
    );
}